import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {
  ChangeStepFeedback,
  FocusNextStep,
  FocusResponse,
  NextStepResponse,
} from '../entities/journey.model';
import { LerApiService } from './ler-api.service';

@Injectable({ providedIn: 'root' })
export class JourneyService extends LerApiService {
  loadJourneyData(): Observable<FocusResponse> {
    return this._get('/v1/ler/focuses/current').pipe(
      map((response) => this._handleResponse(response, 'focus')),
      catchError((response) => this._handleError(response)),
    );
  }

  askNextStep(focusId: number): Observable<FocusNextStep[]> {
    return this._post(`/v1/ler/focuses/${focusId}/next_step`, {}).pipe(
      map((response) => this._handleResponse(response, 'next_steps')),
      catchError((response) => this._handleError(response)),
    );
  }

  markForCompletion(stepId: string): Observable<NextStepResponse> {
    return this._patch(`/v1/ler/next_steps/${stepId}/mark_for_completion`, {}).pipe(
      map((response) => this._handleResponse(response, 'next_step')),
      catchError((response) => this._handleError(response)),
    );
  }

  changeStep(stepId: string, feedback: ChangeStepFeedback): Observable<FocusNextStep> {
    return this._post(`/v1/ler/next_steps/${stepId}/change`, { feedback }).pipe(
      map((response) => this._handleResponse(response, 'next_step')),
      catchError((response) => this._handleError(response)),
    );
  }

  getStepDetails(stepId: string): Observable<FocusNextStep> {
    return this._get(`/v1/ler/next_steps/${stepId}`).pipe(
      map((response) => this._handleResponse(response, 'next_step')),
      catchError((response) => this._handleError(response)),
    );
  }
}
